import { buildLegend } from "@features/sales-v3/utils/tooltip";

export const MODEL_FIT_ACTUAL_ID = "Actual";
export const MODEL_FIT_ACTUAL_COLOR = "#5CBF64";
export const MODEL_FIT_ACTUAL_LEGEND = buildLegend(
  {
    borderColor: MODEL_FIT_ACTUAL_COLOR,
    backgroundColor: MODEL_FIT_ACTUAL_COLOR,
    borderDash: [],
  },
  false,
);

export const MODEL_FIT_PREDICTION_ID = "Predicted";
export const MODEL_FIT_PREDICTION_COLOR = "#7081FF";
export const MODEL_FIT_PREDICTION_BORDER_DASH = [7, 3];
export const MODEL_FIT_PREDICTION_LEGEND = buildLegend(
  {
    borderColor: MODEL_FIT_PREDICTION_COLOR,
    backgroundColor: MODEL_FIT_PREDICTION_COLOR,
    borderDash: MODEL_FIT_PREDICTION_BORDER_DASH,
  },
  false,
);

export const MODEL_FIT_PREDICTION_HDI_ID = "predicted_hdi";
export const MODEL_FIT_PREDICTION_HDI_COLOR = "#D5D8FF";
export const MODEL_FIT_PREDICTION_HDI_LEGEND = buildLegend(
  {
    borderColor: MODEL_FIT_PREDICTION_HDI_COLOR,
    backgroundColor: MODEL_FIT_PREDICTION_HDI_COLOR,
    borderDash: [],
  },
  true,
);

export const MODEL_FIT_SEASONALITY_ID = "Baseline";
export const MODEL_FIT_SEASONALITY_COLOR = "#C825A8";
export const MODEL_FIT_SEASONALITY_LEGEND = buildLegend(
  {
    borderColor: MODEL_FIT_SEASONALITY_COLOR,
    backgroundColor: MODEL_FIT_SEASONALITY_COLOR,
    borderDash: [],
  },
  false,
);

export const MODEL_FIT_SPEND_ID = "Spend";
export const MODEL_FIT_SPEND_COLOR = "#F05F33";
export const MODEL_FIT_SPEND_LEGEND = buildLegend(
  {
    borderColor: MODEL_FIT_SPEND_COLOR,
    backgroundColor: MODEL_FIT_SPEND_COLOR,
    borderDash: [],
  },
  false,
);
